<template>
  <div>
    <b-row>
      <b-col class="col-md-2">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="search"
        />
      </b-col>

      <b-col class="col-md-2 ml-auto text-right">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.modal-add-place-of-work
          class="mt-1"
          variant="primary"
          @click="editPlaceOfWork = {ru: '', uz: ''}"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
          />
          {{$t('general.add')}}
        </b-button>
      </b-col>
    </b-row>

    <!--  ==============================  TABLE_SECTION START ============================== -->
    <b-table
      :items="GET_PLACE_OF_WORK.results"
      :fields="columns"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
     
      <template #cell(title)="props">
        <span>{{ props.item.title[$i18n.locale] }}</span>
      </template>
     
      <template #cell(actions)="props">
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-add-place-of-work
            size="sm"
            class="mt-50 mb-50"
            variant="warning"
            @click="editTableRow(props.item)"
          >
            <feather-icon icon="EditIcon" size="15" />
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="ml-1 mt-50 mb-50"
            variant="danger"
            @click="handleDelete(props)"
          >
            <feather-icon icon="TrashIcon" size="15" />
          </b-button>
        </div>
      </template>
    </b-table>
    <!--  ==============================  TABLE_SECTION END ============================== -->
    





    <!--  ==============================  PAGINATION_SECTION START ============================== -->
    <Pagination
      :nobody="nobody"
      :rows="GET_PLACE_OF_WORK.count"
      :params="params"
      @refresh="refresh()"
    />
    <!--  ==============================  PAGINATION_SECTION END ============================== -->





    <addEditModal :editPlaceOfWork="editPlaceOfWork" />
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import areYouSure from '@/mixins/areYouSure'
import addEditModal from './addEditModal.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BTable,
    AppSearchInput,
    addEditModal,
    Pagination,
  },
  directives: {
    Ripple,
  },
  mixins: [
    areYouSure,
  ],
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      editPlaceOfWork: {ru: '', uz: ''},
      nobody: false,
      params: {
        search: "",
        page_size: 10,
        page: 1,
      },
      // ===============  PRIMARY_DATA_SECTION END ===============



      // ===============  OTHERS_SECTION START ===============
      columns: [
        {
          label: '№',
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          label: 'namee',
          key: 'title',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
      ],
      // ===============  OTHERS_SECTION END ===============



    }
  },
  computed: {
    ...mapGetters('placeOfWork', ['GET_PLACE_OF_WORK']),
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============


  },
  methods: {
    ...mapActions('placeOfWork', ['FETCH_PLACE_OF_WORK', 'DELETE_PLACE_OF_WORK']),

    async refresh(){
      await this.FETCH_PLACE_OF_WORK(this.params)
    },

    editTableRow(item){
      this.$route.params.editMode = true
      this.editPlaceOfWork = item
    },




    // ===============  DELETE_SECTION START ===============
    handleDelete(props) {
      this.$_showAreYouSureModal().then(val => {
          if (val) {
            this.DELETE_PLACE_OF_WORK(props.item.id)
              .then(async () => {
                await this.refresh();
                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              });
          }
        });
    },
    // ===============  DELETE_SECTION END ===============





    // ===============  SEARCH_SECTION START ===============
    async search(text) {
      this.params.search = text
      await this.refresh();
    },
    // ===============  SEARCH_SECTION END ===============




  },
}
</script>
